module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/arrow-to-left-b0caba86e47ef2f87a2f706a52a7e83c.svg";